import React, { createContext } from 'react';

import { Networks } from 'impermax-sdk';

export interface NetworkI {
    networkName: string;
}

const NETWORK = process.env.NETWORK as Networks;

const context: NetworkI = {
    networkName: NETWORK,
};

export const NetworkContext = createContext<NetworkI>(context);

const Network = ({ children }) => {
    return <NetworkContext.Provider value={context}>{children}</NetworkContext.Provider>;
};

export default Network;
